import { Modal } from '@vzmi/shp_shared_compo'

const PreSubmitModal = props => {
  const {
    visible,
    onCancel,
    onOk,
    title,
    children
  } = props
  return (
    <Modal
      visible={visible}
      onOk={onOk}
      onCancel={onCancel}
      title={title}
      className='pre-submit-modal'
    >
      {children}
    </Modal>
  )
}

export default PreSubmitModal
